import React, { useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { toast } from 'sonner';
import { useCart } from '@/context/CartContext';
import { formatApiError } from '@/lib/api';
import { Button } from '@/components/ui/button';
import { ShoppingCart, Plus, Loader2 } from 'lucide-react';

/**
 * Pulsante "Aggiungi al carrello" per i PRODOTTI E-Commerce.
 * Usa il carrello COMUNE (kind='product'). Pattern login-pendente per gli ospiti.
 *
 * @param {string} ownerId  - id del negozio (owner)
 * @param {string} productId - id del prodotto
 * @param {string} [variantId] - id variante (obbligatoria se il prodotto ha varianti)
 * @param {number} [qty=1]
 */
export function AddProductButton({
  ownerId, productId, variantId = null, qty = 1, title = 'questo prodotto',
  label = 'Aggiungi al carrello', size = 'default', variant = 'default',
  className = '', iconOnly = false, stopPropagation = false, disabled = false,
  onAdded,
}) {
  const navigate = useNavigate();
  const location = useLocation();
  const { addProduct, openMiniCart, isCustomer } = useCart() || {};
  const [loading, setLoading] = useState(false);

  const handle = async (e) => {
    if (stopPropagation) { e.preventDefault(); e.stopPropagation(); }
    if (!ownerId || !productId) return;
    const payload = { owner_id: ownerId, product_id: productId, variant_id: variantId, qty };
    if (!isCustomer) {
      try { sessionStorage.setItem('sila_pending_add', JSON.stringify({ type: 'product', ...payload })); } catch (err) { /* noop */ }
      const next = encodeURIComponent(location.pathname + location.search);
      toast.info('Accedi per aggiungere al carrello');
      navigate(`/cliente/accedi?next=${next}`);
      return;
    }
    setLoading(true);
    try {
      await addProduct(payload);
      openMiniCart();
      toast.success(`"${title}" aggiunto al carrello`);
      if (onAdded) onAdded();
    } catch (err) {
      toast.error(formatApiError(err?.response?.data?.detail) || 'Prodotto non disponibile');
    } finally {
      setLoading(false);
    }
  };

  return (
    <Button type="button" size={size} variant={variant} className={className} onClick={handle}
      disabled={loading || disabled} data-testid={`add-product-${productId}`} aria-label={label}>
      {loading ? <Loader2 className={iconOnly ? 'h-4 w-4 animate-spin' : 'mr-2 h-4 w-4 animate-spin'} />
        : (iconOnly ? <ShoppingCart className="h-4 w-4" /> : <Plus className="mr-2 h-4 w-4" />)}
      {!iconOnly && label}
    </Button>
  );
}

export default AddProductButton;
